import React, { FC, useState } from 'react'
import { Box, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

interface IReadMoreProps {
  text: string
  maxCharacters: number
  readMoreLabel?: string
  readLessLabel?: string
}

const useStyles = makeStyles(() => ({
  viewMoreLink: {
    color: brandColors.skyBlue6,
    cursor: 'pointer',
  },
}))

export const ReadMore: FC<IReadMoreProps> = ({
  maxCharacters,
  readLessLabel = 'Read less',
  readMoreLabel = 'Read more',
  text,
}) => {
  const classes = useStyles()
  const [showMoreDetails, setShowMoreDetails] = useState<boolean>(false)
  const textExceedsMaxChar = text ? text.length > maxCharacters : false
  const computedText =
    textExceedsMaxChar && !showMoreDetails ? `${text?.slice(0, maxCharacters)}...` : text
  const onViewMoreClickHandler = () => {
    setShowMoreDetails(!showMoreDetails)
  }

  return (
    <Box component='span'>
      {computedText}
      {textExceedsMaxChar && (
        <Box onClick={onViewMoreClickHandler} component='span' className={classes.viewMoreLink}>
          {' '}
          {showMoreDetails ? readLessLabel : readMoreLabel}
        </Box>
      )}
    </Box>
  )
}
